.event-calendar {
  display: flex;
  position: relative;
  box-sizing: border-box;
  flex: 1;
  flex-direction: column;
  width: 100%;
  min-height: 0;
  max-height: 100%;
  border: var(--rc-calendar-border-base);
  border-radius: var(--rc-calendar-border-radius-base);
  font-family: var(--rc-calendar-font-family);
}

.event-calendar-month {
  display: flex;
  flex-direction: column;
  height: 100%;
  min-height: 0;
  overflow: hidden;
}
